var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"action-link block",class:{ active: _vm.isActiveLink },attrs:{"to":_vm.link}},[_c('v-icon',{attrs:{"color":_vm.color || 'black',"small":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }